import React from 'react';
import './Hero.css';
import heroImage from '../assets/hero2.jpg';

const Hero = () => {
  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${heroImage})`
  };

  return (
    <section id="home" className="hero" style={heroStyle}>
      <div className="container">
        <div className="hero-content">
          <div className="hero-logo">
            <img src="/logo.png" alt="Auto-Kar" className="hero-logo-img" />
          </div>
          <h1 className="hero-title">
            Profesjonalny Warsztat Samochodowy
            <span className="highlight"> Auto-Kar</span>
          </h1>
          <p className="hero-subtitle">
            Specjalizujemy się w kompleksowych usługach samochodowych. 
            Od remontów kapitalnych silników po diagnostykę komputerową - 
            zapewniamy najwyższą jakość usług dla Twojego pojazdu.
          </p>
          <div className="hero-buttons">
            <a href="#services" className="btn btn-primary">
              Nasze Usługi
            </a>
            <a href="#contact" className="btn btn-secondary">
              Skontaktuj się
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 